import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: 'login.component.html',
  styles: [],
  standalone: false
})
export class LoginComponent implements OnInit, OnDestroy {
  isInvalidConnection: boolean;
  connection: string;
  sub: Subscription;
  constructor(
    private auth: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private appConfigService: AppConfigService
  ) {}

  ngOnInit() {
    this.connection = this.route.snapshot.queryParams['connection'];
    this.sub = this.auth.isAuthenticated$.subscribe((isAuthenticated) => {
      if (isAuthenticated) {
        let redirect_uri = sessionStorage.getItem('redirect_uri') ?? '/home';
        this.router.navigate(['callback'], { queryParams: { redirect_uri: redirect_uri } });
        sessionStorage.removeItem('redirect_uri');
        return;
      }
      if (!this.connection) {
        this.auth.login();
      } else if (this.appConfigService.tenant.connections.includes(this.connection)) {
        this.auth.login(this.connection);
      } else {
        this.isInvalidConnection = true;
      }
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
